import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";

import { BsPersonCircle } from "react-icons/bs";
import { FaSignOutAlt } from "react-icons/fa";
import {useNavigate, useLocation } from "react-router-dom";

import "../css/Personalizado.css";

function Header() {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const location = useLocation();
  const [nombre, setNombre] = useState("");

  useEffect(() => {
    // if (!cookies.get("idUsuario")) {
    //   navigate("/");
    // } else {
    //   setNombre(cookies.get("nombre") || "");
    // }
  }, [location]);

  const cerrarSesion = () => {
    cookies.remove("idUsuario", { path: "/" });
    cookies.remove("nombreUsuario", { path: "/" });
    cookies.remove("nombre", { path: "/" });
    cookies.remove("apellido", { path: "/" });
    cookies.remove("correo", { path: "/" });
    cookies.remove("estado", { path: "/" });
    cookies.remove("rol", { path: "/" });
    navigate("/");
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      {/* Left navbar links */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="#" role="button">
            <i className="fas fa-bars" />
          </a>
        </li>
      </ul>

      {/* Right navbar links */}
      <ul className="navbar-nav ml-auto align-items-center">
        <li className="user-info">
          <span className="username">
            <BsPersonCircle
              style={{ fontSize: "1.5rem", marginRight: "6px" }}
            />
            {/* {nombre} */}
            {"Stiven Mican"}
          </span>
          <button className="btn btn-sm btn-logout" onClick={cerrarSesion}>
            <FaSignOutAlt className="mr-1" />
            Cerrar sesión
          </button>
        </li>

        <li className="nav-item">
          <a
            className="nav-link"
            data-widget="fullscreen"
            href="#"
            role="button"
          >
            <i className="fas fa-expand-arrows-alt" />
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
